var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ul-main"},[_c('el-upload',{ref:"upload",staticClass:"avatar-uploader",attrs:{"action":_vm.path,"accept":"image/*","limit":1,"name":"file","headers":{
			token:_vm.token
		},"data":{
			sysCode:'tmc-etsms',
			timeout: -1,
			token:_vm.token
		},"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeAvatarUpload}},[(_vm.imageUrl)?_c('el-image',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }